import React, { FC, PropsWithChildren } from "react";
import classnames from "classnames";

import "./index.scss";

export type StatsCardProps = PropsWithChildren<{ className?: string }>;

type StatsCardComponents = {
  Title: FC<PropsWithChildren>;
  Desc: FC<React.PropsWithChildren>;
};

const Title: FC<StatsCardProps> = ({ children, className }) => {
  return <div className={classnames("stats-card-title", className)}>{children}</div>;
};

const Desc: FC<StatsCardProps> = ({ children, className }) => {
  return <div className={classnames("stats-card-desc", className)}>{children}</div>;
};

export const StatsCard: FC<StatsCardProps> & StatsCardComponents = ({ children, className }) => {
  return <div className={classnames("stats-card", className)}>{children}</div>;
};

StatsCard.Title = Title;

StatsCard.Desc = Desc;
